import { render } from "./user-manual.vue?vue&type=template&id=b2df81fc"
import script from "./user-manual.vue?vue&type=script&lang=js"
export * from "./user-manual.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__